import React from 'react';
import AntConfigProvider from 'antd-core/es/config-provider';
import { css, createGlobalStyle } from 'styled-components';
import { Language } from '@10d/tend-ui-locale';
import { ApiClient } from '@10d/tend-ui-api';
import { colors } from '@10d/tend-ui-tokens/samolet';
import { createAntdTheme } from './utils.js';
import { SamoletTheme } from './SamoletTheme.js';
import { ConfigProvider } from './ConfigProvider.js';
import { Theme } from './Theme.js';

const styles = css `
  /* Menu */
  .tend-ui-menu-submenu-popup .tend-ui-menu-vertical.tend-ui-menu-sub {
    padding: 8px 0;
  }

  /* Dialog */
  .tend-ui-modal-confirm {
    &.tend-ui-modal-confirm-image {
      .tend-ui-modal-confirm-body {
        flex-direction: column;
        align-items: center;

        & > .anticon {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 24px;
          margin-inline-end: 0px;
          font-size: 48px;
          border-radius: 50%;
          width: 80px;
          height: 80px;
        }
      }
    }
    &.tend-ui-modal-confirm-image-cover {
      .tend-ui-modal-content {
        padding: 0px;
      }
      .tend-ui-modal-confirm-paragraph {
        padding: 0 32px;
      }
    }
    &.tend-ui-modal-confirm-info,
    &.tend-ui-modal-confirm-success,
    &.tend-ui-modal-confirm-warning,
    &.tend-ui-modal-confirm-error {
      .tend-ui-modal-confirm-title {
        margin-top: 12px;
      }
      .tend-ui-modal-confirm-body {
        & > .anticon {
          font-size: 40px;
        }
      }
    }

    .tend-ui-modal-confirm-paragraph {
      gap: 12px;
    }
  }

  /* Toast */
  .tend-ui-notification
    .tend-ui-notification-notice
    .tend-ui-notification-notice-with-icon {
    .tend-ui-notification-notice-message {
      font-family: Museo Sans Cyrl;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;

      margin-inline-start: 42px;
      margin-bottom: 0;
    }

    .tend-ui-notification-notice-description {
      font-family: Museo Sans Cyrl;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;

      margin-inline-start: 42px;
      min-height: 12px;
    }
  }

  /* Workaround for Chrome animation flickering */
  .tend-ui-notification-stack > .tend-ui-notification-notice-wrapper {
    transition: all 0.3s, backdrop-filter 0s, opacity 0s;
  }

  .tend-ui-notification .tend-ui-notification-notice {
    .tend-ui-notification-notice-close {
      inset-inline-end: 12px;
      padding: 2px;
      width: unset;
      height: unset;
      &:hover {
        background-color: transparent;
      }
    }

    .tend-ui-notification-notice-icon {
      padding: 2px;
    }

    /* Neutral icon */
    &.tend-ui-notification-notice-neutral .tend-ui-notification-notice-icon {
      &.tend-ui-notification-notice-icon-info {
        color: ${colors.gray400};
      }
    }

    &.tend-ui-notification-notice-loading .tend-ui-notification-notice-icon {
      color: ${colors.gray400};
    }
  }
`;
const GlobalStyles = createGlobalStyle `${styles}`;
const TendUI = ({ lang = 'ru', theme = 'samolet', client, children, }) => {
    return (React.createElement(ApiClient, { client: client },
        React.createElement(Theme, { theme: theme },
            React.createElement(GlobalStyles, null),
            React.createElement(Language, { language: lang },
                React.createElement(ConfigProvider, null, children)))));
};
TendUI.init = (theme = SamoletTheme) => {
    AntConfigProvider.config({
        prefixCls: 'tend-ui',
        theme: createAntdTheme(theme),
    });
};

export { TendUI };
//# sourceMappingURL=TendUI.js.map
